import React from "react";
import { useEffect, useState, useRef } from "react";
import { useNavigate } from "react-router-dom";
import { viewreconciliationlist} from "../../../../components/CommonSection/apiresources";
import { GetCookie } from "../../../../components/CommonSection/Cookie/Session";
import { makeRequestWithSpinner } from "../../../../Utilities/client";
import { useSpinnerContext } from "../../../../Utilities/SpinnerContext";
import "../../../../components/Dashboard/Dashboard-agent/AgentList.css";
import { ActionStatus } from "../../../../Utilities/enum";
import { addParametersForProfiles } from "../../../../Utilities/profileManagement";
import SubNav from "../../../navbar/subNav";
import { message} from 'antd';
import moment from "moment";
import ToastAlert from "../../../../components/CommonSection/ToastAlert/ToastAlert";
import AntdTableExample from "../../../input-components/dataTable";
import { format } from 'date-fns';

const Reconciliations = () => {
    const [reconciliationsLists, setReconciliationsList] = useState([]);
    const [userId, setUserId] = useState("");
    const [agencyID, setAgencyId] = useState("");
    const navigate = useNavigate();
    const [searchText, setSearchText] = useState("");
    const [purpose, setPurpose] = useState(1);
    const { showSpinner, hideSpinner } = useSpinnerContext();
    const [totalPages, setTotalPages] = useState(0);
    const [agentId, setAgentId] = useState("");
    const ToastRef = useRef();


    useEffect(() => {
        const retrieveData = async () => {
            try {
                const userData = GetCookie("@UserData");
                if (userData) {
                    const parsedData = JSON.parse(userData);
                    setAgentId(parsedData.agentId)
                    setUserId(parsedData.userId);
                    setAgencyId(parsedData.agencyID);
                }
            } catch (error) {
                console.error("Error retrieving data from AsyncStorage:", error);
            }
        };
        retrieveData();
    }, [userId]);

    useEffect(() => {
        if (userId) getReconciliationList(1, 10);
    }, [userId, searchText, purpose]);

     
    const getReconciliationList = (currentPage, totalRows) => {
        const baseUrl = viewreconciliationlist + `?AgencyId=${agencyID}`;
        makeRequestWithSpinner(showSpinner, hideSpinner, baseUrl, "get")
            .then((response) => {
                if (response.status === ActionStatus.Successfull) {
                    let reconciliationData = response.object;
                    let reconciliationList1 = reconciliationData.bankReconciliationList.map((dis) => {
                        let statusText = '';
                        if (dis.isClosed && dis.isApproved) {
                            statusText = 'Approved and Closed';
                        } else if (!dis.isClosed && dis.isApproved) {
                            statusText = 'Period Not Closed';
                        } else if (!dis.isApproved && !dis.isClosed) {
                            statusText = 'Reconcile and Approve';
                        }
                    
                        const formattedAmount = dis.bankStatementAmount?.toLocaleString('en-US', {
                            style: 'currency',
                            currency: 'USD',
                        }) || '$0.00';
                    
                        const statementDate = dis.bankStatementAmountDate
                            ? format(new Date(dis.bankStatementAmountDate), 'd MMMM yyyy')
                            : null;
                    
                        return {
                            month: `${moment(dis.month).format("MMMM YYYY")}${dis.isCurrent ? " (current)" : ""}`, // ✅ formatted + conditional
                            bankStatement: `${formattedAmount}${statementDate ? ' on ' + statementDate : ''}`,
                            Status: statusText,
                        };
                    });
                    
                      
                    setReconciliationsList(reconciliationList1);
                } else {
                    message.error(response.message)
                    alert(`Message: ${response.message}`);
                }
            })
            .catch((error) => {
                console.error("Error:", error);
            });
    };

   const handleViewMonth = (data) => {
    console.log(data,'ppp')
    navigate(`/agency/accounts/viewReconciliations?date=${data}`)
   }
              
   const tabColumns = {
    Status: {
      colorMap: {
        "Approved and Closed": "green",
        "Period Not Closed": "orange",
        "Reconcile and Approve" : "gray"
      },
      defaultColor: 'blue'
    }
  };

    return (
        <div>
            <div className="col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12 px-0 changedateantdstyle">
                <div className="col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12 px-0 daily-date-style">
                    <SubNav title={"Reconciliations"} goback={false} extraData={true} />
                    <div className="material-work-desk-new bg-white m-3 p-3">
                        <AntdTableExample
                            label="Monthly Reconciliations"
                            dataSource={reconciliationsLists}
                            globalSearch
                            hideCol={"id"}
                            highlightColumns={{
                                month: '#2980b9',
                            }}
                            onMonthClick={(month) => handleViewMonth(month)}
                            tagColumns={tabColumns}
                        />
                    </div>

                </div>
            </div>
        </div>
    );
};

export default Reconciliations;
